module.exports = __webpack_public_path__ + "img/St_Philips.bdb96aab.jpg";